import * as React from 'react';

import { Header, VStack } from '@rbilabs/universal-components';

import SanityBlockRenderer from 'components/sanity-block-renderer';

import { getQuestTermsText } from '../custom-text';

import { IQuestTermsProps } from './types';

export const QuestTerms = ({ cmsQuestTerms }: IQuestTermsProps) => {
  if (!cmsQuestTerms?.localeRaw) {
    return null;
  }

  return (
    <VStack space="$4" marginTop="$8" marginBottom="$8">
      <Header variant="headerThree" fontWeight="normal" margin={0}>
        {getQuestTermsText()}
      </Header>
      <SanityBlockRenderer textProps={{ variant: 'copyTwo' }} content={cmsQuestTerms.localeRaw} />
    </VStack>
  );
};
